import type { NodeV2 } from '@vedalib/editor'
import { DeviceMode } from '@vedalib/editor'
import type { EditorElement } from '@vedalib/editor/lib/elements'
import cn from 'classnames'
import React, { useCallback } from 'react'

import { remapComplexNode } from 'components/Editor/NodeV2/Picker/complexNodes'
import ScaledNode from 'components/Editor/NodeV2/ScaledNode'
import { IconButton } from 'components/uiKit/Button'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { preventDefault } from 'constants/commonConstans'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getBlock } from 'services/Store/Project/selectors'
import type { Block, MapType } from 'services/Store/Project/types'

import * as s from './TileNode.module.scss'

interface ITileNodeProps {
  item: NodeV2
  onDelete?: (item: NodeV2) => void
  elements?: MapType<EditorElement>
  parent: NodeV2
  nodes?: MapType<NodeV2>
  stash?: boolean
  block: Block
  onAdd: (
    node: NodeV2,
    data?: { nodes?: MapType<NodeV2>; elements?: MapType<EditorElement> },
  ) => void
  image?: string
}

const TileNode: React.FC<ITileNodeProps> = ({
  item,
  // parent,
  elements,
  nodes,
  stash,
  image,
  onDelete,
  onAdd,
}) => {
  const block = useProjectContext(getBlock)

  const handleClick = useCallback(() => {
    if (stash) {
      onAdd(item)
    } else {
      const data = remapComplexNode({ root: item, elements, nodes })

      onAdd(data.root, data)
    }
  }, [onAdd, stash, item, elements, nodes])

  return (
    <div className={s.root} onClick={handleClick}>
      <div className={cn(s.item, { [s[item.style.desktop.display || 'element']]: !image })}>
        {image ? (
          <img className={s.image} onMouseDown={preventDefault} src={image} />
        ) : (
          <ScaledNode
            deviceMode={DeviceMode.desktop}
            elements={elements || block?.elements}
            node={item}
            nodes={nodes || block?.schema.nodes}
          />
        )}
      </div>
      <Typography rows={1}>{item.label}</Typography>
      {onDelete && (
        <div className={s.removeButton}>
          <IconButton
            icon='trashDeleteBin'
            name='delete'
            onClick={() => onDelete(item)}
            size={KitSize.XS}
            styleType='secondary'
          />
        </div>
      )}
    </div>
  )
}

export default TileNode
